import React from 'react';
import {Box, Paper, Typography} from '@mui/material';

type SettingsCardProps = {
    title: string;
    description?: string;
    // Shown at the right of the title, e.g. a primary button.
    action?: React.ReactNode;
    children: React.ReactNode;
};

// One group of related settings: a titled, outlined card.
export function SettingsCard({title, description, action, children}: SettingsCardProps) {
    return (
        <Paper variant="outlined" sx={{p: {xs: 2, sm: 3}, borderRadius: 2, minWidth: 0}}>
            <Box sx={{display: 'flex', alignItems: 'flex-start', justifyContent: 'space-between', flexWrap: 'wrap', gap: 2, mb: 2.5, pb: 2, borderBottom: 1, borderColor: 'divider'}}>
                <Box sx={{minWidth: 0}}>
                    <Typography variant="h6" component="h2">{title}</Typography>
                    {description && (
                        <Typography variant="body2" color="text.secondary" sx={{mt: 0.5}}>{description}</Typography>
                    )}
                </Box>
                {action}
            </Box>
            {children}
        </Paper>
    );
}
